import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Box from '@mui/material/Box';
import { ChapterColumn, ChapterColumnProps } from './chapter-column';

export function SortableChapterColumn(props: ChapterColumnProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: props.chapter.id,
    data: {
      type: 'container',
      chapter: props.chapter
    }
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 10 : undefined,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      sx={{
        height: '100%',
        display: 'flex',
        '&:hover .drag-handle': {
          opacity: 0.6
        }
      }}
    >
      <ChapterColumn
        {...props}
        dragAttributes={attributes}
        dragListeners={listeners}
      />
    </Box>
  );
}
